import styled from '@emotion/styled';
import { Magnetic } from '@mitchell/react.component.ux';
const StyleCommentDivBaseImage = `
	background-repeat: no-repeat;
	background-size: cover;
	background-position: center;
	outline: ${Magnetic.buttonFlatBorder};
	border: ${Magnetic.buttonFlatBorder};
`;
export const StyledImageCommentCorner = styled('img') `
	${StyleCommentDivBaseImage}
	margin-bottom: ${Magnetic.spacer16};
	@media (max-width: ${Magnetic.layoutBreakpointSm}) {
		width: 100%;
	}
`;
export const StyledDivCommentImageContainer = styled('div') `
	text-align: center;
	position: ${Magnetic.menuContainerPosition};
	padding: ${Magnetic.spacer20} ${Magnetic.spacer24} ${Magnetic.spacer24};
	overflow: auto;
	margin: ${Magnetic.spacer12} 0 ${Magnetic.spacer24} 0;
`;
export const StyledCommentTitle = styled('div') `
	font-weight: ${Magnetic.fontWeightHeavy};
	margin-bottom: ${Magnetic.spacer16};
	@media (max-width: ${Magnetic.layoutBreakpointSm}) {
		text-align: left;
	}
`;
export const StyledInnerCommentBoxContainer = styled('div') `
	margin-top: ${Magnetic.spacer24};
	padding: 0 ${Magnetic.spacer24};
	text-align: center;
`;
export const StyledCommentContainer = styled('div') `
	margin-bottom: ${Magnetic.spacer16};
`;
export const StyledCommentInnerContainer = styled('div') `
	padding: 0 ${Magnetic.spacer24};
	@media (max-width: ${Magnetic.layoutBreakpointSm}) {
		padding: 0;
	}
`;
export const StyledMultiCommentContainer = styled('div') `
	margin-bottom: ${Magnetic.spacer12};
`;
export const StyledThumbnailContainer = styled('div') `
	height: '175px';
	width: '175px';
	display: flex;
	justify-content: center;
	margin-bottom: ${Magnetic.spacer16};
`;
//# sourceMappingURL=PhotoCaptureMultiCommentComponent.style.js.map